import { RootState } from "../../app/store";

export const selectMenu = (state: RootState) => state.layout.menu;